export default "__VITE_ASSET__CWGcB5hS__"